import type { ExamSection, QuestionType } from '@examflow/core';
import { createSectionConstraint } from '@examflow/core';
import { TOPIKSection } from './types';
import {
  topikListeningDefinition,
  topikReadingDefinition,
  topikWritingDefinition,
} from './questionTypes';

/**
 * TOPIK 听力配置
 * name：运营中文主文案 + 官方原文（见 sectionDisplayName.ts）
 */
export const TOPIK_LISTENING_SECTION: ExamSection = {
  id: TOPIKSection.LISTENING,
  name: '听力 (듣기)',
  duration: 60, // TOPIK II 参考时长
  /** TOPIK II listening: 50 items. */
  questionCount: 50,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(topikListeningDefinition.id)],
};

/**
 * TOPIK 阅读配置
 */
export const TOPIK_READING_SECTION: ExamSection = {
  id: TOPIKSection.READING,
  name: '阅读 (읽기)',
  duration: 70, // TOPIK II 参考时长
  /** TOPIK II reading: 50 items. */
  questionCount: 50,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(topikReadingDefinition.id)],
};

/**
 * TOPIK 写作配置 (仅 TOPIK II)
 */
export const TOPIK_WRITING_SECTION: ExamSection = {
  id: TOPIKSection.WRITING,
  name: '写作 (쓰기)',
  duration: 50, // TOPIK II 参考时长
  /** TOPIK II writing: 4 items (short + essay prompts). */
  questionCount: 4,
  questionTypes: ['fill_blank' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(topikWritingDefinition.id)],
};

/**
 * TOPIK II 考试部分（3项）
 */
export const TOPIK_SECTIONS: ExamSection[] = [
  TOPIK_LISTENING_SECTION,
  TOPIK_READING_SECTION,
  TOPIK_WRITING_SECTION,
];

/**
 * 获取部分配置
 */
export function getTOPIKSection(sectionId: TOPIKSection): ExamSection | undefined {
  return TOPIK_SECTIONS.find((s) => s.id === sectionId);
}

/**
 * 获取总考试时长（分钟）
 */
export function getTotalDuration(): number {
  return TOPIK_SECTIONS.reduce((sum, section) => sum + section.duration, 0);
}
